<template>
  <suggestions-table :view="view"/>
</template>

<script>
import { mapState } from 'vuex'
import suggestionsTable from './table'

export default {
  components: {
    suggestionsTable
  },
  computed: {
    ...mapState('suggestions', {
      view: '_readView'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/suggestions/read.vue